import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSearchOptions: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="search-options, settings"><path d="M7.5 16.5C10.5376 16.5 13 14.0376 13 11C13 7.96243 10.5376 5.5 7.5 5.5C4.46243 5.5 2 7.96243 2 11C2 14.0376 4.46243 16.5 7.5 16.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15 18.5L11.5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17 10L19.5 12.5L22 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSearchOptions;
